import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserManagementService } from 'src/app/services/user-management.service';

@Component({
  selector: 'app-corrective-maintenance',
  templateUrl: './corrective-maintenance.component.html'
})
export class CorrectiveMaintenanceComponent {
  isThisSectionVisible = false;

  toggleVisibility() {
    console.log(this.isThisSectionVisible);
    this.isThisSectionVisible = !this.isThisSectionVisible;
  }

  @Input()
  parentForm!: FormGroup;
  correctiveMainServiceTimesRb!: string;

  @Output()
  openHelpModal: EventEmitter<any> = new EventEmitter();

  constructor(private userManagementService: UserManagementService) {}

  getUserRole() {
    return this.userManagementService.getUserRole();
  }
}
